export const SCROLL_EACH_NUMBER = 5;

const moreThanZero = index => index > 0;
const modScrollNumberEqZero = index => index % SCROLL_EACH_NUMBER === 0;

const scrollRules = [moreThanZero, modScrollNumberEqZero];

export const isScrollNeeded = activeIndex => {
  const someRuleIsFailed = scrollRules.some(rule => !rule(activeIndex));

  return !someRuleIsFailed;
};

export const getScrollIndexMovingUp = activeIndex =>
  Math.max(activeIndex - SCROLL_EACH_NUMBER, 0);

export const containsNonEmptyOptions = options => {
  return options.some(o => (typeof o === "object" ? o.value !== "" : o !== ""));
};

export const AUTOCOMPLETE_TEST_IDS = {
  suggestionsList: "autocomplete-suggestions-list",
  singleSuggestionPattern: index => `autocomplete-suggestion-${index}`,
  inputPattern: name => `autocomplete-${name}`
};

export const AUTOCOMPLETE_TERM_NAME = "term";

export const KEY_CODES = {
  enter: 13,
  arrowDown: 40,
  arrowUp: 38
};

export const AUTOCOMPLETE_CLASSNAMES = {
  activeSuggestion: "autocomplete-suggestionActive-web-sdk"
};
